import React, { useMemo, useState } from 'react'
import { DatePicker } from 'antd'
import moment from 'moment'
import { canViewStoreName } from '../../../services/StorageServices'

const { MonthPicker } = DatePicker

const TableStorePackage = (props) => {
    const canViewStore = canViewStoreName()
    const { month1, month2, onChangeMonth2, storePackageReport = {} } = props
    const [sortBy, setSortBy] = useState('prevPackageIssueTotal')
    const [time, setTime] = useState('previous')
    const [sortPrevPackageIssueTotal, setSortPrevPackageIssueTotal] = useState(true)
    const [sortPrevPackageTotal, setSortPrevPackageTotal] = useState(true)
    const [sortPrevPercent, setSortPrevPercent] = useState(true)
    const [sortTargetPackageIssueTotal, setSortTargetPackageIssueTotal] = useState(true)
    const [sortTargetPackageTotal, setSortTargetPackageTotal] = useState(true)
    const [sortTargetPercent, setSortTargetPercent] = useState(true)

    const { groupByStore = {}, prevPackageIssueTotal = 0, prevPackageTotal = 0, targetPackageIssueTotal = 0, targetPackageTotal = 0 } = Object.assign({}, storePackageReport)
    const data = useMemo(() => {
        return Object.entries(groupByStore).map(([key, value]) => ({
            store: key,
            ...value
        }))
    }, [storePackageReport])

    const dataSorted = React.useMemo(() => {
        if (sortBy === 'prevPackageIssueTotal') {
            if (sortPrevPackageIssueTotal) {
                return data.sort((a, b) => a[time].packageIssueTotal - b[time].packageIssueTotal)
            } else {
                return data.sort((a, b) => b[time].packageIssueTotal - a[time].packageIssueTotal)
            }
        }

        if (sortBy === 'prevPackageTotal') {
            if (sortPrevPackageTotal) {
                return data.sort((a, b) => a[time].packageTotal - b[time].packageTotal)
            } else {
                return data.sort((a, b) => b[time].packageTotal - a[time].packageTotal)
            }
        }

        if (sortBy === 'prevPercent') {
            if (sortPrevPercent) {
                return data.sort((a, b) => {
                    const a1 = Number(((a[time].packageIssueTotal / (a[time].packageTotal || 0)) * 100))
                    const b1 = Number(((b[time].packageIssueTotal / (b[time].packageTotal || 0)) * 100))
                    return a1 - b1
                })
            } else {
                return data.sort((a, b) => {
                    const a1 = Number(((a[time].packageIssueTotal / (a[time].packageTotal || 0)) * 100))
                    const b1 = Number(((b[time].packageIssueTotal / (b[time].packageTotal || 0)) * 100))
                    return b1 - a1
                })
            }
        }

        if (sortBy === "targetPackageIssueTotal") {
            if (sortTargetPackageIssueTotal) {
                return data.sort((a, b) => a[time].packageIssueTotal - b[time].packageIssueTotal)
            } else {
                return data.sort((a, b) => b[time].packageIssueTotal - a[time].packageIssueTotal)
            }
        }

        if (sortBy === 'targetPackageTotal') {
            if (sortTargetPackageTotal) {
                return data.sort((a, b) => a[time].packageTotal - b[time].packageTotal)
            } else {
                return data.sort((a, b) => b[time].packageTotal - a[time].packageTotal)
            }
        }

        if (sortBy === 'targetPercent') {
            if (sortTargetPercent) {
                return data.sort((a, b) => {
                    const a1 = Number(((a[time].packageIssueTotal / (a[time].packageTotal || 0)) * 100))
                    const b1 = Number(((b[time].packageIssueTotal / (b[time].packageTotal || 0)) * 100))
                    return a1 - b1
                })
            } else {
                return data.sort((a, b) => {
                    const a1 = Number(((a[time].packageIssueTotal / (a[time].packageTotal || 0)) * 100))
                    const b1 = Number(((b[time].packageIssueTotal / (b[time].packageTotal || 0)) * 100))
                    return b1 - a1
                })
            }
        }

    }, [sortPrevPackageIssueTotal, sortPrevPackageTotal, sortPrevPercent, sortTargetPackageIssueTotal, sortTargetPackageTotal, sortTargetPercent, sortBy, data])

    const handleSortPackage = (field, sortField, setSort, time) => {
        setTime(time)
        setSortBy(field)
        setSort(!sortField)
    }

    const showPercentIssue = (number, total) => {
        if (total === 0) return 0

        const percent = ((+number / +total) * 100)
        return !!percent ? Number(percent.toFixed(2)) : 0
    }

    const renderTable = ({
        className,
        month,
        onChangeMonth,
        packageIssueTotal,
        sortPackageIssueTotal,
        keySortPackageIssueTotal,
        setPackageIssueTotal,
        packageTotal,
        sortPackageTotal,
        keySortPackageTotal1,
        setSortPackageTotal,
        sortPercent,
        keySortPercent1,
        key,
        setSortPercent,
        dataMap
    }) => {
        return (
            <table className={className}>
                <thead>
                    <tr>
                        {key !== 'target' && canViewStore && <th rowSpan={3} className='col-store'>Store</th>}
                        <th colSpan="3" className="text-center">
                            {
                                key === "target" ?
                                    <MonthPicker
                                        allowClear={false}
                                        value={month}
                                        onChange={onChangeMonth}
                                        format="MMMM YYYY"
                                        className='custom-month-issue-report-store'
                                    /> : <MonthPicker
                                        allowClear={false}
                                        value={month}
                                        format="MMMM YYYY"
                                        style={{ pointerEvents: 'none' }}
                                        className='custom-month-issue-report-store'
                                    />
                            }
                        </th>
                    </tr>
                    <tr>
                        <th>Tổng số đơn lỗi</th>
                        <th>Tổng số đơn</th>
                        <th>Tỷ lệ đơn lỗi</th>
                    </tr>
                    <tr>
                        <th className='text-right'>
                            {packageIssueTotal}
                            {
                                sortPackageIssueTotal ?
                                    <i
                                        className={`fa fa-long-arrow-up cursor-pointer p-1 ${sortBy === keySortPackageIssueTotal && "text-primary"}`}
                                        onClick={() => handleSortPackage(keySortPackageIssueTotal, sortPackageIssueTotal, setPackageIssueTotal, key)}
                                    /> :
                                    <i
                                        className={`fa fa-long-arrow-down cursor-pointer p-1 ${sortBy === keySortPackageIssueTotal && "text-primary"}`}
                                        onClick={() => handleSortPackage(keySortPackageIssueTotal, sortPackageIssueTotal, setPackageIssueTotal, key)}
                                    />
                            }
                        </th>
                        <th className='text-right'>
                            {packageTotal}
                            {
                                sortPackageTotal ?
                                    <i
                                        className={`fa fa-long-arrow-up cursor-pointer p-1 ${sortBy === keySortPackageTotal1 && "text-primary"}`}
                                        onClick={() => handleSortPackage(keySortPackageTotal1, sortPackageTotal, setSortPackageTotal, key)}
                                    /> :
                                    <i
                                        className={`fa fa-long-arrow-down cursor-pointer p-1 ${sortBy === keySortPackageTotal1 && "text-primary"}`}
                                        onClick={() => handleSortPackage(keySortPackageTotal1, sortPackageTotal, setSortPackageTotal, key)}
                                    />
                            }
                        </th>
                        <th className='text-right'>
                            {`${showPercentIssue(packageIssueTotal, packageTotal)}%`}
                            {
                                sortPercent ?
                                    <i
                                        className={`fa fa-long-arrow-up cursor-pointer p-1 ${sortBy === keySortPercent1 && "text-primary"}`}
                                        onClick={() => handleSortPackage(keySortPercent1, sortPercent, setSortPercent, key)}
                                    /> :
                                    <i
                                        className={`fa fa-long-arrow-down cursor-pointer p-1 ${sortBy === keySortPercent1 && "text-primary"}`}
                                        onClick={() => handleSortPackage(keySortPercent1, sortPercent, setSortPercent, key)}
                                    />
                            }
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {dataMap.map((row, index) => {
                        const { previous = {}, target = {}, store = '' } = Object.assign({}, row)
                        const { packageIssueTotal = 0, packageTotal = 0 } = Object.assign({}, key === 'target' ? target : previous)
                        const isNotification = showPercentIssue(packageIssueTotal, packageTotal) > 2
                        return (
                            <tr key={index}>
                                {key !== 'target' && canViewStore && <td className='col-store'>{store}</td>}
                                <td className='text-right' style={{ backgroundColor: isNotification ? "#f7d9da" : 'transparent' }}>{packageIssueTotal}</td>
                                <td className='text-right' style={{ backgroundColor: isNotification ? "#f7d9da" : 'transparent' }}>{packageTotal}</td>
                                <td className='text-right' style={{ backgroundColor: isNotification ? "#f7d9da" : 'transparent' }}>{`${showPercentIssue(packageIssueTotal, packageTotal)}%`}</td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        )
    }

    return (
        <div className="table PackageIssueStoreReportTable d-flex">
            {
                renderTable({
                    className: 'table-left',
                    month: month1,
                    packageIssueTotal: prevPackageIssueTotal,
                    sortPackageIssueTotal: sortPrevPackageIssueTotal,
                    keySortPackageIssueTotal: 'prevPackageIssueTotal',
                    setPackageIssueTotal: setSortPrevPackageIssueTotal,
                    packageTotal: prevPackageTotal,
                    sortPackageTotal: sortPrevPackageTotal,
                    keySortPackageTotal1: 'prevPackageTotal',
                    setSortPackageTotal: setSortPrevPackageTotal,
                    sortPercent: sortPrevPercent,
                    keySortPercent1: 'prevPercent',
                    key: 'previous',
                    setSortPercent: setSortPrevPercent,
                    dataMap: dataSorted
                })
            }
            {
                renderTable({
                    className: 'table-right',
                    month: month2,
                    onChangeMonth: onChangeMonth2,
                    packageIssueTotal: targetPackageIssueTotal,
                    sortPackageIssueTotal: sortTargetPackageIssueTotal,
                    keySortPackageIssueTotal: 'targetPackageIssueTotal',
                    setPackageIssueTotal: setSortTargetPackageIssueTotal,
                    packageTotal: targetPackageTotal,
                    sortPackageTotal: sortTargetPackageTotal,
                    keySortPackageTotal1: 'targetPackageTotal',
                    setSortPackageTotal: setSortTargetPackageTotal,
                    sortPercent: sortTargetPercent,
                    keySortPercent1: 'targetPercent',
                    key: 'target',
                    setSortPercent: setSortTargetPercent,
                    dataMap: dataSorted
                })
            }

            <table className="table" style={{ display: 'none' }} id="Issue_Store_Package_Report">
                <thead style={{ display: 'none' }}>
                    <tr>
                        {canViewStore && <th rowSpan={3} className='col-store'>Store</th>}
                        <th colSpan="3" className="text-center">
                            {moment(month1).format('MMMM YYYY')}
                        </th>
                        <th colSpan="3" className="text-center">
                            {moment(month2).format('MMMM YYYY')}
                        </th>
                    </tr>
                    <tr>
                        <th>Tổng số đơn lỗi</th>
                        <th>Tổng số đơn</th>
                        <th>Tỷ lệ đơn lỗi</th>
                        <th>Tổng số đơn lỗi</th>
                        <th>Tổng số đơn</th>
                        <th>Tỷ lệ đơn lỗi</th>
                    </tr>
                    <tr>
                        <th className='text-right'>
                            {storePackageReport.prevPackageIssueTotal || 0}
                            {
                                sortPrevPackageIssueTotal ?
                                    <i
                                        className={`fa fa-long-arrow-up cursor-pointer p-1 ${"prevPackageIssueTotal" === sortBy && "text-primary"}`}
                                        onClick={() => handleSortPackage('prevPackageIssueTotal', sortPrevPackageIssueTotal, setSortPrevPackageIssueTotal, 'previous')}
                                    /> :
                                    <i
                                        className={`fa fa-long-arrow-down cursor-pointer p-1 ${"prevPackageIssueTotal" === sortBy && "text-primary"}`}
                                        onClick={() => handleSortPackage('prevPackageIssueTotal', sortPrevPackageIssueTotal, setSortPrevPackageIssueTotal, 'previous')}
                                    />
                            }
                        </th>
                        <th className='text-right'>
                            {storePackageReport.prevPackageTotal || 0}
                            {
                                sortPrevPackageTotal ?
                                    <i
                                        className={`fa fa-long-arrow-up cursor-pointer p-1 ${"prevPackageTotal" === sortBy && "text-primary"}`}
                                        onClick={() => handleSortPackage('prevPackageTotal', sortPrevPackageTotal, setSortPrevPackageTotal, 'previous')}
                                    /> :
                                    <i
                                        className={`fa fa-long-arrow-down cursor-pointer p-1 ${"prevPackageTotal" === sortBy && "text-primary"}`}
                                        onClick={() => handleSortPackage('prevPackageTotal', sortPrevPackageTotal, setSortPrevPackageTotal, 'previous')}
                                    />
                            }
                        </th>
                        <th className='text-right'>
                            {`${showPercentIssue(prevPackageIssueTotal, prevPackageTotal)}%`}
                            {
                                sortPrevPercent ?
                                    <i
                                        className={`fa fa-long-arrow-up cursor-pointer p-1 ${"prevPercent" === sortBy && "text-primary"}`}
                                        onClick={() => handleSortPackage('prevPercent', sortPrevPercent, setSortPrevPercent, 'previous')}
                                    /> :
                                    <i
                                        className={`fa fa-long-arrow-down cursor-pointer p-1 ${"prevPercent" === sortBy && "text-primary"}`}
                                        onClick={() => handleSortPackage('prevPercent', sortPrevPercent, setSortPrevPercent, 'previous')}
                                    />
                            }
                        </th>
                        <th className='text-right'>
                            {storePackageReport.targetPackageIssueTotal || 0}
                            {
                                sortTargetPackageIssueTotal ?
                                    <i
                                        className={`fa fa-long-arrow-up cursor-pointer p-1 ${"targetPackageIssueTotal" === sortBy && "text-primary"}`}
                                        onClick={() => handleSortPackage('targetPackageIssueTotal', sortTargetPackageIssueTotal, setSortTargetPackageIssueTotal, 'target')}
                                    /> :
                                    <i
                                        className={`fa fa-long-arrow-down cursor-pointer p-1 ${"targetPackageIssueTotal" === sortBy && "text-primary"}`}
                                        onClick={() => handleSortPackage('targetPackageIssueTotal', sortTargetPackageIssueTotal, setSortTargetPackageIssueTotal, 'target')}
                                    />
                            }
                        </th>
                        <th className='text-right'>
                            {storePackageReport.targetPackageTotal || 0}
                            {
                                sortTargetPackageTotal ?
                                    <i
                                        className={`fa fa-long-arrow-up cursor-pointer p-1 ${"targetPackageTotal" === sortBy && "text-primary"}`}
                                        onClick={() => handleSortPackage('targetPackageTotal', sortTargetPackageTotal, setSortTargetPackageTotal, 'target')}
                                    /> :
                                    <i
                                        className={`fa fa-long-arrow-down cursor-pointer p-1 ${"targetPackageTotal" === sortBy && "text-primary"}`}
                                        onClick={() => handleSortPackage('targetPackageTotal', sortTargetPackageTotal, setSortTargetPackageTotal, 'target')}
                                    />
                            }
                        </th>
                        <th className='text-right'>
                            {`${showPercentIssue(targetPackageIssueTotal, targetPackageTotal)}%`}
                            {
                                sortTargetPercent ?
                                    <i
                                        className={`fa fa-long-arrow-up cursor-pointer p-1 ${"targetPercent" === sortBy && "text-primary"}`}
                                        onClick={() => handleSortPackage('targetPercent', sortTargetPercent, setSortTargetPercent, 'target')}
                                    /> :
                                    <i
                                        className={`fa fa-long-arrow-down cursor-pointer p-1 ${"targetPercent" === sortBy && "text-primary"}`}
                                        onClick={() => handleSortPackage('targetPercent', sortTargetPercent, setSortTargetPercent, 'target')}
                                    />
                            }
                        </th>
                    </tr>
                </thead>
                <tbody style={{ display: 'none' }}>
                    {dataSorted.map((row, index) => {
                        const { previous = {}, target = {}, store = '' } = Object.assign({}, row)
                        const isNotificationPrev = showPercentIssue(previous.packageIssueTotal, previous.packageTotal) > 2
                        const isNotificationTarget = showPercentIssue(target.packageIssueTotal, target.packageTotal) > 2

                        return (
                            <tr key={index}>
                                {canViewStore && <td className='col-store'>{store}</td>}
                                <td
                                    className='text-right'
                                    style={{
                                        backgroundColor: !isNotificationPrev ? "transparent" : '#f7d9da'
                                    }}
                                >{previous.packageIssueTotal}
                                </td>
                                <td
                                    className='text-right'
                                    style={{ backgroundColor: !isNotificationPrev ? "transparent" : '#f7d9da' }}
                                >{previous.packageTotal}
                                </td>
                                <td
                                    className='text-right'
                                    style={{ backgroundColor: !isNotificationPrev ? "transparent" : '#f7d9da' }}
                                >{`${showPercentIssue(previous.packageIssueTotal, previous.packageTotal)}%`}
                                </td>
                                <td
                                    className='text-right'
                                    style={{ backgroundColor: !isNotificationTarget ? "transparent" : '#f7d9da' }}
                                >{target.packageIssueTotal}
                                </td>
                                <td
                                    className='text-right'
                                    style={{ backgroundColor: !isNotificationTarget ? "transparent" : '#f7d9da' }}
                                >{target.packageTotal}
                                </td>
                                <td
                                    className='text-right'
                                    style={{ backgroundColor: !isNotificationTarget ? "transparent" : '#f7d9da' }}
                                >{`${showPercentIssue(target.packageIssueTotal, target.packageTotal)}%`}
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    )
}

export default TableStorePackage